export default __webpack_public_path__ + "static/media/delaswap-text.679d7841.png";